<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<em class="lt_text">Invoice Date</em>
					<span class="mgr_5"> <CustomYearPicker v-model="from_year"/> ~ <CustomYearPicker v-model="to_year"/></span>

					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_5"
						><CodeSelect className="tbl_select" :codes="restriction_only && state_report_filters ? state_report_filters.restrictionOnlySalesGroupList : salesGroups" :displayDescription="true" v-model="sales_group_code"
					/></span>

					<em class="lt_text">Salesman</em>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="reformattedSalesmans" :displayDescription="false" v-model="salesman_id"/></span>

					<em class="lt_text">Country</em>
					<span class="int_type_no_border">
						<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="country" @post-loading="postCountryLoading" />
					</span>
					<label class="mgr_10"><input type="checkbox" @change="excludeUS" v-model="exception" /> Non-US</label>

					<em class="lt_text">State</em>
					<span class="int_type_no_border mgr_15"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" :key="stateElKey" /> </span>

					<em class="lt_text">City</em>
					<span class="int_type_no_border mgr_15"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="cities" v-model="city" :key="cityElKey" /> </span>

					<span class="int_type ssm_int">
						<input type="text" class="ssm_int" v-model.trim="from_zip_code" title="From Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>
					~
					<span class="int_type ssm_int mgr_5">
						<input type="text" class="ssm_int" v-model.trim="to_zip_code" title="To Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				</p>
				<p class="mgb_5"><select-multi-payment-term v-model="paymentTerm" /></p>

				<select-partners :restrictionOnly="restriction_only" v-model="partner_string" class="mgb_5" />
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 2%;" />
						<col style="width: 4%;" />
						<col />
						<col style="width: 4%;" />
						<col style="width: 5%;" />
						<col style="width: 3%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
						<col style="width: 5%;" />
					</colgroup>
					<thead>
						<tr>
							<th>No</th>
							<th>Partner</th>
							<th>Partner Name</th>
							<th>Salesman</th>
							<th>Payment Term</th>
							<th>Year</th>
							<th>1</th>
							<th>2</th>
							<th>3</th>
							<th>4</th>
							<th>5</th>
							<th>6</th>
							<th>7</th>
							<th>8</th>
							<th>9</th>
							<th>10</th>
							<th>11</th>
							<th>12</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="sales in root.list">
							<tr :key="sales.sales_group_code">
								<td colspan="19">{{ sales.sales_group_code + ' / ' + sales.sales_group_name }}</td>
							</tr>
							<template v-for="(partner, index) in sales.list">
								<tr v-for="(year, index2) in partner.list" v-bind:key="sales.sales_group_code + partner.bill_to_code + year.year">
									<template v-if="index2 === 0">
										<td class="al_left" v-bind:rowspan="partner.list.length">{{ index + 1 }}</td>
										<td class="al_left" v-bind:rowspan="partner.list.length">{{ partner.bill_to_code }}</td>
										<td class="al_left" v-bind:rowspan="partner.list.length">{{ partner.bill_to_name }} {{ '(' + partner.address_detail + ', ' + partner.address_city + ')' }}</td>
										<td class="al_left" v-bind:rowspan="partner.list.length">{{ partner.salesman_name }}</td>
										<td class="al_left" v-bind:rowspan="partner.list.length">{{ partner.payment_term_name }}</td>
									</template>
									<td class="al_center">{{ year.year }}</td>
									<td class="al_right">{{ year.january | toCurrency }}</td>
									<td class="al_right">{{ year.february | toCurrency }}</td>
									<td class="al_right">{{ year.march | toCurrency }}</td>
									<td class="al_right">{{ year.april | toCurrency }}</td>
									<td class="al_right">{{ year.may | toCurrency }}</td>
									<td class="al_right">{{ year.june | toCurrency }}</td>
									<td class="al_right">{{ year.july | toCurrency }}</td>
									<td class="al_right">{{ year.august | toCurrency }}</td>
									<td class="al_right">{{ year.september | toCurrency }}</td>
									<td class="al_right">{{ year.october | toCurrency }}</td>
									<td class="al_right">{{ year.november | toCurrency }}</td>
									<td class="al_right">{{ year.december | toCurrency }}</td>
									<td class="al_right">{{ year.total_amount | toCurrency }}</td>
								</tr>
							</template>
							<tr v-for="(year, index) in sales.amountList" v-bind:key="sales.sales_group_code + index">
								<td class="al_center" v-if="index === 0" v-bind:rowspan="sales.amountList.length" colspan="5">Total</td>
								<td class="al_center">{{ year.year }}</td>
								<td class="al_right">{{ year.january | toCurrency }}</td>
								<td class="al_right">{{ year.february | toCurrency }}</td>
								<td class="al_right">{{ year.march | toCurrency }}</td>
								<td class="al_right">{{ year.april | toCurrency }}</td>
								<td class="al_right">{{ year.may | toCurrency }}</td>
								<td class="al_right">{{ year.june | toCurrency }}</td>
								<td class="al_right">{{ year.july | toCurrency }}</td>
								<td class="al_right">{{ year.august | toCurrency }}</td>
								<td class="al_right">{{ year.september | toCurrency }}</td>
								<td class="al_right">{{ year.october | toCurrency }}</td>
								<td class="al_right">{{ year.november | toCurrency }}</td>
								<td class="al_right">{{ year.december | toCurrency }}</td>
								<td class="al_right">{{ year.total_amount | toCurrency }}</td>
							</tr>
						</template>

						<tr v-for="(year, index) in root.yearAmountList" v-bind:key="'T' + index">
							<td class="al_center" v-if="index === 0" v-bind:rowspan="root.yearAmountList.length" colspan="5">Grand Total</td>
							<td class="al_center">{{ year.year }}</td>
							<td class="al_right">{{ year.january | toCurrency }}</td>
							<td class="al_right">{{ year.february | toCurrency }}</td>
							<td class="al_right">{{ year.march | toCurrency }}</td>
							<td class="al_right">{{ year.april | toCurrency }}</td>
							<td class="al_right">{{ year.may | toCurrency }}</td>
							<td class="al_right">{{ year.june | toCurrency }}</td>
							<td class="al_right">{{ year.july | toCurrency }}</td>
							<td class="al_right">{{ year.august | toCurrency }}</td>
							<td class="al_right">{{ year.september | toCurrency }}</td>
							<td class="al_right">{{ year.october | toCurrency }}</td>
							<td class="al_right">{{ year.november | toCurrency }}</td>
							<td class="al_right">{{ year.december | toCurrency }}</td>
							<td class="al_right">{{ year.total_amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="exportRawDataToExcel()">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import { apiIndex, apiSalesTemplate, apiSalesTemplateByRawData } from '@/api/report/report';
import { apiSelectStateListBySalesGroup } from '@/api/search/search.js';
import { apiGetReportTemplate, exportDataExcel, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import CustomYearPicker from '@/components/common/CustomYearPicker';
import CodeSelect from '@/components/common/CodeSelect';
import { toYear } from '@/utils/date';
import { convertFalsyToEmpty } from '@/utils/etc';
import SelectPartners from '@/components/common/SelectPartners';
import SelectMultiPaymentTerm from '@/components/common/SelectMultiPaymentTerm';
import { defaultDataType } from 'export-xlsx';
import _ from 'lodash';

export default {
	mixins: [stateReport({ id: 'salesTemplate', search: 'selectData', queries: ['selectData'], results: ['cities', 'reportData', 'root'] })],
	data: function() {
		return {
			root: '',
			reportData: '',
			from_year: toYear(),
			to_year: toYear(),
			salesmans: [],
			salesman_id: '',
			salesGroups: [],
			sales_group_code: '',
			countries: [],
			country: '',
			state: '',
			states: [],
			sg_states: [],
			city: '',
			cities: [],
			exception: false,
			partner_string: '',
			partners: [],
			paymentTerm: '',

			saveParam: {},

			stateElKey: 0, // CodeSelect에 선택된 값 초기화를 위해 사용
			cityElKey: 0,

			from_zip_code: '',
			to_zip_code: '',
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		filteredStates: function() {
			if (this.restriction_only && this.state_report_filters) return (this.state_report_filters.restrictionOnlyStateList || []).filter(state => !this.country || state.country === this.country);
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			const vm = this;
			let base_states = null;
			if (this.user.company_id === 'beautyplus' && this.sales_group_code) {
				if (!this.country) return this.sg_states;
				base_states = this.sg_states;
			} else {
				base_states = this.states;
			}

			let fStates = base_states.filter(s => s.country === vm.country);
			if (fStates.length === 0) vm.state = null;
			return fStates;
		},
		reformattedSalesmans() {
			// if (this.sales_group_code) {
			// 	let salesTeamCode = this.salesGroups.find(sg => sg.code === this.sales_group_code).sales_team_code;
			// 	if (salesTeamCode) {
			// 		return this.salesmans.filter(sm => sm.sales_team_code === salesTeamCode).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
			// 	} else {
			// 		return [];
			// 	}
			// } else {
			// 	return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
			// }
			if (this.sales_group_code && this.user.company_id == 'beautyplus') return this.salesmans.filter(sm => sm.sales_group_code == this.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));

			return _.uniqBy(this.salesmans, 'user_id').map(sm => ({ code: sm.user_id, name: sm.name }));
		},
	},
	watch: {
		sales_group_code: {
			async handler() {
				if (this.restriction_only) {
					this.sg_states = [];
					return;
				}
				if (this.sales_group_code) {
					const { data } = await apiSelectStateListBySalesGroup(this.sales_group_code);
					this.sg_states = data.value || [];
				} else {
					this.sg_states = [];
				}
			},
		},
	},
	components: {
		SelectMultiPaymentTerm,
		CustomYearPicker,
		CodeSelect,
		SelectPartners,
	},
	methods: {
		async selectData() {
			this.partners = this.partner_string ? this.partner_string.split(/ |,/) : [];

			if (!this.cities.some(city => city.code === this.city)) {
				this.city = '';
			}

			const paramObj = {
				from_year: this.from_year || '1900',
				to_year: this.to_year || '9999',
				salesman_id: convertFalsyToEmpty(this.salesman_id),
				sales_group_code: convertFalsyToEmpty(this.sales_group_code),
				exception_yn: this.exception ? 'Y' : 'N',
				country: this.exception ? this.findUSCode() : convertFalsyToEmpty(this.country),
				state: convertFalsyToEmpty(this.state),
				partners: this.partners || [],
				paymentTerm: this.paymentTerm || [],
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
				city: this.city,
			};
			this.saveParam = objectToFormData(paramObj);

			const { data } = await apiSalesTemplate.call(this, this.saveParam);
			this.root = data.value;
			const { addressCityList, ...cleanedValue } = data.value;
			this.cities = addressCityList.filter(city => city !== null);
			this.reportData = data;
			this.reportData.value = cleanedValue;
		},
		async exportRawDataToExcel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (!(this.saveParam instanceof FormData)) {
				this.$toast.error('No Data.');
				return;
			}

			const fileName = 'sales_template';
			const { data } = await apiSalesTemplateByRawData.call(this, this.saveParam);
			const headers = [
				{ key: 'bill_to_code', name: 'Partner', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Partner Name', width: 30, dataType: defaultDataType.string },
				{ key: 'sales_group_code', name: 'Sales Group Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group Name', width: 15, dataType: defaultDataType.string },
				{ key: 'salesman_id', name: 'Salesman Id', width: 15, dataType: defaultDataType.string },
				{ key: 'salesman_name', name: 'Salesman Name', width: 15, dataType: defaultDataType.string },
				{ key: 'country_name', name: 'Country', width: 15, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'State', width: 15, dataType: defaultDataType.string },
				{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
				{ key: 'year', name: 'Year', width: 15, dataType: defaultDataType.currency },
				{ key: 'january', name: '1', width: 15, dataType: defaultDataType.number },
				{ key: 'february', name: '2', width: 15, dataType: defaultDataType.number },
				{ key: 'march', name: '3', width: 15, dataType: defaultDataType.number },
				{ key: 'april', name: '4', width: 15, dataType: defaultDataType.number },
				{ key: 'may', name: '5', width: 15, dataType: defaultDataType.number },
				{ key: 'june', name: '6', width: 15, dataType: defaultDataType.number },
				{ key: 'july', name: '7', width: 15, dataType: defaultDataType.number },
				{ key: 'august', name: '8', width: 15, dataType: defaultDataType.number },
				{ key: 'september', name: '9', width: 15, dataType: defaultDataType.number },
				{ key: 'october', name: '10', width: 15, dataType: defaultDataType.number },
				{ key: 'november', name: '11', width: 15, dataType: defaultDataType.number },
				{ key: 'december', name: '12', width: 15, dataType: defaultDataType.number },
				{ key: 'total_amount', name: 'Total', width: 15, dataType: defaultDataType.number },
			];

			if (this.user.company_id == 'hairplus') {
				headers.splice(9, 0, { key: 'address_detail', name: 'Address', width: '25', dataType: defaultDataType.string });
				headers.splice(10, 0, { key: 'address_zipcode', name: 'Zipcode', width: '10', dataType: defaultDataType.string });
				headers.splice(11, 0, { key: 'telephone', name: 'Telephone', width: '15', dataType: defaultDataType.string });
			}

			if (!state_output.valid) return;

			exportDataExcel(data, headers, fileName);
		},
		async reportPrint() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (!this.root) return;

			this.root.type = 'print';

			if (this.salesman_id) this.reportData.value.salesman_name = this.salesmans.find(sm => sm.user_id == this.salesman_id).name;
			else this.reportData.value.salesman_name = '';
			console.log(this.reportData.value);
			const reportTemplate = await apiGetReportTemplate('SalesTemplate', reportMrtUrl('SalesTemplate'));
			const report = new Report(reportTemplate, this.reportData, 'SalesTemplate');
			this.$store.commit('setReport', { ...report, state_scope_context: state_output });
		},
		async index() {
			const { data } = await apiIndex();
			this.salesmans = data.salesmanList;
			this.salesGroups = data.salesGroupList;
			this.states = data.stateList;
			this.countries = data.countryList;
		},
		findUSCode() {
			let res = '';

			if (this.isValidCountryCode('US')) res = 'US';
			else if (this.isValidCountryCode('USA')) res = 'USA';

			return res;
		},
		isValidCountryCode(code) {
			return this.countries.findIndex(c => c.code === code) > -1;
		},
		postCountryLoading() {
			this.country = this.findUSCode();
		},
		excludeUS() {
			if (this.exception) {
				this.country = '';
				this.state = '';
				this.stateElKey++;
			} else {
				this.postCountryLoading();
			}
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesTemplate');
		this.$store.commit('setSubTitle', 'Report -> Sales Template');
		this.index();
	},
	mounted() {
		// this.$store.commit('setSideIndex', 7);
		// this.$store.commit('setSelectedMenu', 'nav_li_salesTemplate');
		// this.$store.commit('setSubTitle', 'Report -> Sales Template');
		// this.index();
	},
};
</script>

<style scoped></style>
